<template>
    <header class="header">
        <layout-logo/>
        <layout-menu/>
    </header>
</template>

<script>

    import LayoutLogo from './elements/LayoutLogo';
    import LayoutMenu from './elements/LayoutMenu';

    export default {
        name: "layout-component",

        components:{
            LayoutLogo,
            LayoutMenu
        }
    }
</script>

<style scoped lang="less">
    @import "../../assets/css/style.less";
    .header{
        width: 100%;
        height: @top-bar-height;
        background-color: @theme-color;
        line-height: @top-bar-height;
        &:after{
            .clearBoth()
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/LayoutComponent.vue